var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfileSummary = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "57px",
    viewBox: "0 0 48 57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-659.000000, -305.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(659.043478, 305.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.47248783,0.0826445211 L44.9161197,1.75870479 C45.9758115,1.80262042 46.8169535,2.66610821 46.833076,3.726587 L47.6000972,54.1784192 C47.6168627,55.2811901 46.737743,56.1893956 45.6350104,56.208521 L2.12511755,56.9631426 C1.02071414,56.9822971 0.10989056,56.1025289 0.090736142,54.9981255 C0.0900332793,54.9575999 0.0905625064,54.9170624 0.09232309,54.8765689 L2.39156283,1.99405485 C2.43947332,0.892113706 3.37045158,0.0369740631 4.47248783,0.0826445211 Z",
    fill: "#F4DB6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8695652,39.3217391 L33.1070234,39.3217391",
    stroke: "#007674",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8695652,46.7565217 L33.1070234,45.9304348",
    stroke: "#007674",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.869565, 9.582609)",
    fill: "#007674"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2297113,19.6386704 C18.2297113,15.4836234 14.1488514,12.1152923 9.11485565,12.1152923 C4.08085988,12.1152923 0,15.4836234 0,19.6386704 C0,23.7937174 18.2297113,23.7937174 18.2297113,19.6386704 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.81300066,
    cy: 5.46144657,
    rx: 5.07867835,
    ry: 5.46144657
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfileSummary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile-summary.94e8afe708e55882d878e680faae3aae.svg";